<template>
  <div>
    <page-title
      title="Your experience"
      description="Now, let’s add all your professional work experience starting with most recent. At least one entry is required for your profile to be approved."
    />

    <div class="mt-5">
      <step-item-card
        v-for="(item, i) in details.positions"
        :key="i"
        :title="item.position_name"
        :from="dateStr(item.start_date)"
        :to="dateStr(item.end_date)"
        :description="item.company_name"
        :details="item.job_details"
        @edit="editItem(i)"
      />
      <!-- <step-item-card
        v-for="i in 2"
        :key="i"
        title="Frontend developer"
        from="2015"
        to="2021"
        description="Receive Gmbh"
        details="Front-end development for debt collection management and analytics software. We use an AWS serverless stack with CQRS event-driven architecture. We built a landing page where end-custome..."
      /> -->
    </div>

    <add-step-item-cta title="experience" @click="showExpDialog = true" />

    <add-experience
      :position="position"
      :is-active="showExpDialog"
      :action-type="indexToEdit ? 'update' : 'add'"
      @close="showExpDialog = false"
      @confirm="addPosition"
    />
  </div>
</template>

<script setup>
import PageTitle from './PageTitle.vue';
import AddStepItemCta from './AddStepItemCta.vue';
import StepItemCard from './StepItemCard.vue';
import AddExperience from './AddExperience.vue';
import { ref, onMounted } from 'vue';
import { alert, dateStr } from '@/utils/helper';

const props = defineProps({
  details: {
    type: Object,
  },
});

const position = ref({
  position_name: '',
  company_name: '',
  country: '',
  start_date: '',
  end_date: '',
  job_details: '',
});
const showExpDialog = ref(false);
const indexToEdit = ref(null);

const editItem = (index) => {
  indexToEdit.value = index;
  position.value = props.details.positions[index];
  showExpDialog.value = true;
};

const addPosition = () => {
  const { position_name, company_name, country, start_date, end_date, job_details } = position.value;
  if (!position_name || !company_name || !start_date || !end_date || !job_details) return alert('Please fill all required fields', 'error');

  if (indexToEdit.value == null) {
    props.details.positions.push(position.value);
  } else {
    props.details.positions[indexToEdit.value] = position.value;
    indexToEdit.value = null;
  }

  position.value = {
    position_name: '',
    company_name: '',
    country: '',
    start_date: '',
    end_date: '',
    job_details: '',
  };
  showExpDialog.value = false;
};
</script>
